module.exports = __webpack_public_path__ + "img/ui.264a2b88.svg";